"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a JSON parsed object if the input
 * is a string. Otherwise returns the input
 * unchanged.
 *
 * Cleans the returned value by removing empty
 * objects from arrays.
 *
 * @param value The value to convert/return.
 *
 * @returns The JSON parsed value
 */
function getJSONValue(value) {
    if (typeof value === 'string') {
        var cleaned = value.replace(/,{}/g, '').replace(/\[{}/g, '[');
        return JSON.parse(cleaned);
    }
    return value;
}
exports.default = getJSONValue;
//# sourceMappingURL=getJSONValue.js.map